import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const Hero = () => {
    const [muted, setMuted] = useState(true);
    const [videoSrc, setVideoSrc] = useState(null);
    const [loading, setLoading] = useState(true);
    const videoRef = useRef(null);

    // cPanel Live Domain aur Localhost dono ke liye URL configuration
    const baseUrl = window.location.hostname === "localhost"
        ? 'http://66.116.250.115:9000' // Agar aap direct IP use kar rahe hain
        : "https://rajkurumaenterprises.com";
    useEffect(() => {
        axios.get(`${baseUrl}/api/get-video/`)
            .then(res => {
                if (res.data.url) {
                    const fullUrl = res.data.url.startsWith('http')
                        ? res.data.url
                        : `${baseUrl}${res.data.url}`;
                    setVideoSrc(fullUrl);
                }
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching video:", err);
                setLoading(false);
            });
    }, [baseUrl]);

    // Muted state change hone par video reload nahi hogi, direct property update hogi
    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = muted;
        }
    }, [muted]);

    if (loading) return <div className="h-screen bg-black flex items-center justify-center text-white">Loading...</div>;

    return (
        <div className="relative w-full h-screen overflow-hidden bg-black">
            {videoSrc ? (
                <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted={muted}
                    playsInline
                    className="absolute top-0 left-0 w-full h-full object-cover"
                >
                    <source src={videoSrc} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                <div className="absolute inset-0 flex items-center justify-center text-white">
                    No active video found in Admin Panel
                </div>
            )}

            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black/60 z-[5]" />

            {/* Hero Content */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white px-6 text-center z-10">
                {/* Service Tags Section */}
                <div className="text-gray-200 font-medium tracking-[0.25em] uppercase text-[11px] md:text-sm mb-8 flex flex-wrap justify-center gap-4 italic">
                    <span className="text-[#ec212c]">Car Rental</span> <span>•</span>
                    <span className="text-[#de1825]">Real Estate</span> <span>•</span>
                    <span className="text-[#d82032]">Business Setup</span> <span>•</span>
                    <span className="text-[#e6191f]">Relocation Services</span>
                </div>

                <h1 className="text-4xl md:text-7xl font-bold mb-12 text-sky-500">
                    Rajkuruma <span className="text-sky-500">Enterprises</span> Pvt Ltd
                </h1>

                <div className="flex flex-col md:flex-row gap-6">
                    <Link to="/enquiry" className="bg-[#f51a30] text-white px-12 py-4 font-bold rounded-full hover:scale-105 transition-all shadow-lg">
                        Book Service →
                    </Link>
                    <Link to="/contact" className="bg-transparent text-white border-2 border-white px-12 py-4 font-bold rounded-full hover:bg-white hover:text-black transition-all shadow-lg">
                        Contact Us →
                    </Link>
                </div>
            </div>

            {/* Mute/Unmute Button (Floating buttons ke sath overlap na ho isliye position set ki hai) */}
            <button
                className="absolute bottom-6 right-5 md:bottom-10 md:right-24 bg-black/40 backdrop-blur-md p-3 rounded-full z-[60] text-xl text-white hover:bg-black/60 transition shadow-xl"
                onClick={() => setMuted(!muted)}
                title={muted ? "Unmute Video" : "Mute Video"}
            >
                {muted ? "🔇" : "🔊"}
            </button>
        </div>
    );
};

export default Hero;